import { crud, http } from '../../libs/react-mpk/services';

let service = new crud('/support/notification');

export const updateNotificationBulkSupport = (query) => {
    return http.get(`/support/notification/bulk`, query);
};

export default service